import script from "./Finance.vue?vue&type=script&setup=true&lang=js"
export * from "./Finance.vue?vue&type=script&setup=true&lang=js"

import "./Finance.vue?vue&type=style&index=0&id=1f4ade28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4ade28"]])

export default __exports__